<template>
  <keep-alive>
    <component :is="type" v-bind="$attrs"></component>
  </keep-alive>
</template>

<script>
import * as components from '@/components/index'

export default {
  components: {
    ...components
  },
  props: {
    type: { type: String, required: true }
  }
}
</script>
